import React, { useState, useEffect } from 'react';
import '../../assets/css/auth.css';
import Logo from '../../assets/images/logo.svg'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import API_CONFIG from '../../config/api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(false);
  const [errorDetail, setErrorDetail] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('token') !== null) {
      window.location.replace('/admin/');
    } else {
      setLoading(false);
    }
  }, []);

  const onSubmit = e => {
    e.preventDefault();
    setErrors(false);
    setErrorDetail('');

    const user = {
      username: username,
      password: password
    };

    fetch(`${API_CONFIG.baseURL}v3/auth/login/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(user)
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.key) {
          localStorage.clear();
          localStorage.setItem('token', data.key);
          window.location.replace('/admin/');
          return;
        }
        const msg =
          (Array.isArray(data.non_field_errors) && data.non_field_errors[0]) ||
          data.message ||
          'Login fehlgeschlagen.';
        let detail = msg;
        if (data.debug && data.debug.spg_admin_password_in_env === false) {
          detail += ' (SPG_ADMIN_PASSWORD fehlt im API-Container)';
        } else if (data.debug && data.debug.user_found === false) {
          detail += ' (Benutzer nicht in der Datenbank)';
        }
        setUsername('');
        setPassword('');
        localStorage.clear();
        setErrors(true);
        setErrorDetail(detail);
        setLoading(false);
      })
      .catch(() => {
        setErrors(true);
        setErrorDetail('Netzwerkfehler — API nicht erreichbar.');
        setLoading(false);
      });
  };

  return (
    <div className="authenticate-back">
      <span></span>
      <div className="authenticate-center">
        <span></span>
        <div className="authenticate-window">
          <div className="authenticate-logo">
            <img className="authenticate-logo-image" src={Logo} alt="Logo" />
          </div>
          {loading === false && <div className="authenticate-title">Login</div> }
          {errors === true && (
            <div className="authenticate-error">
              {errorDetail || 'Es kann mit den gegebenen Daten nicht eingeloggt werden.'}
            </div>
          )}
          {loading === false && (
            <form onSubmit={onSubmit}>
              <div className="authenticate-placeholder"></div>
              <TextField
                margin="dense"
                id="username"
                label="Benutzername"
                type="username"
                fullWidth
                variant="outlined"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
              <div className="authenticate-placeholder"></div>
              <TextField
                margin="dense"
                id="password"
                label="Passwort"
                type="password"
                fullWidth
                variant="outlined"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <div className="authenticate-placeholder"></div>
              <div className="authenticate-buttons">
                <span></span>
                <span></span>
                <Button type="submit" variant="contained" color="default">
                  Login
                </Button>
              </div>
              <div className="authenticate-placeholder"></div>
            </form>
          )}
        </div>
        <span></span>
      </div>
      <span></span>
    </div>
  );
};

export default Login;
